module.exports = "/assets/data/bf252edcac93f6476b89a284498e2e44-SY1.data.json";